import axiosInstance from './axiosConfig'
import { createCancelToken } from './axiosUtils'

const TransactionAPI = {
  create: function ({ org_id, ...data }) {
    return axiosInstance.request({
      method: 'POST',
      url: `/organizations/${org_id}/transactions`,
      data: data,
    })
  },
  getAll: function ({ org_id, limit, offset }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/transactions`,
      params: { limit, offset },
      cancelToken: cancelTokenObject[this.getAll.name].requestCancellation().token,
    })
  },
  getById: function ({ org_id, transaction_id }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/transactions/${transaction_id}`,
    })
  },
  pay: function ({ org_id, transaction_id }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/organizations/${org_id}/transactions/${transaction_id}/payment`,
    })
  },
  cancel: function ({ org_id, transaction_id }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/organizations/${org_id}/transactions/${transaction_id}/cancel`,
    })
  },
  getPricingInfo: function ({ org_id }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/pricing-information`,
    })
  },
  getSystemBankingInfo: function ({ org_id }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/bank-information`,
    })
  },
  superAdminCancel: function ({ transaction_id, note }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/super-admin/transactions/${transaction_id}/cancel`,
      data: { note },
    })
  },
  superAdminValidate: function ({ transaction_id, note }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/super-admin/transactions/${transaction_id}/validate`,
      data: { note },
    })
  },
  superAdminGetAll: function (params) {
    return axiosInstance.request({
      method: 'GET',
      url: `/super-admin/transactions`,
      params,
      cancelToken: cancelTokenObject[this.superAdminGetAll.name].requestCancellation().token,
    })
  },
}

const cancelTokenObject = createCancelToken(TransactionAPI)
export default TransactionAPI
